import {
    Component,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-send-invoice-filter',
    templateUrl: './send-invoice-filter.component.html',
    styleUrls: ['./send-invoice-filter.component.scss'],
    standalone: false
})
export class SendInvoiceFilterComponent implements OnChanges {
    @Input() startDate: Date;
    @Input() endDate: Date;
    public moment: any = moment;
    public filterFormGroup: UntypedFormGroup;
    @Output() public Filter = new ReplaySubject<{
        StartDate: Date;
        EndDate: Date;
        Resend: boolean;
    }>(1);

    constructor(private log: LoggingService) {
        this.filterFormGroup = new UntypedFormGroup({
            StartDate: new UntypedFormControl(null),
            EndDate: new UntypedFormControl(null),
            Resend: new UntypedFormControl(false)
        });

        this.filterFormGroup.valueChanges.subscribe(value => {
            this.log.verbose({
                type: 'SendInvoiceFilterComponent:filterFormGroup:valueChanges',
                value
            });
            this.Filter.next(value);
        });
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.startDate) {
            this.filterFormGroup.patchValue({
                StartDate: changes.startDate.currentValue
            });
        }
        if (changes.endDate) {
            this.filterFormGroup.patchValue({
                EndDate: changes.endDate.currentValue
            });
        }
    }
}
